<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select class="" v-model="selectedOrganizationBranch" :options="organizationBranchOptions">
                    <span slot="no-options">{{ $t('vSelect.noRowsToShow') }}</span>
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 md:mt-0 mt-4 w-full">
                <label class="vs-input--label">Thời gian</label>
                <date-range-picker
                    ref="picker"
                    :locale-data="{format: 'dd/mm/yyyy' }"
                    :opens="'right'"
                    @update="dateRangePicker"
                    v-model="dateRange" class="w-full">
                </date-range-picker>
            </div>
            <div class="vx-col md:w-1/3 md:mt-0 mt-4 w-full">
                <label class="vs-input--label">Tìm kiếm</label>
                <vs-input class="w-full" v-model="searchQuery"
                          @input="updateSearchQuery" placeholder="Tìm kiếm ...">
                </vs-input>
            </div>
            <div class="vx-col w-full">
                <div class="flex mt-6">
                    <vs-button @click="filter" color="primary" icon="icon-search" icon-pack="feather" class="mr-2"> Tìm kiếm
                    </vs-button>
                    <vs-button color="primary" icon="icon-settings" iconPack="feather" type="border" @click="addHoliday"
                               v-if="isPermissionAdd()">
                        Thêm ngày nghỉ lễ
                    </vs-button>
                </div>
            </div>
        </div>

        <ag-grid-vue style="height: 55vh" ref="agGridTable"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="holidayData"
                     :animateRows="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                     paginationPageSize="10"
                     :pagination="true"
                     @pagination-changed="onPaginationChanged"
                     @grid-ready="onGridReady"
                     :autoSizeStrategy="autoSizeStrategy"
                     tooltipShowDelay="0"
                     tooltipHideDelay="5000">
        </ag-grid-vue>
        <div class="vx-row">
            <div class="vx-col w-full flex">
                <div style="min-width:200px">
                    <span class="content-page font-bold">Hiển thị: </span><span class="text-page">{{
                        countElementPage >
                        totalElements ? totalElements : countElementPage
                    }} / {{ totalElements }} </span>
                </div>
                <vs-pagination :total="totalPages" @change="loadPage" v-model="currentPage"/>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import {AgGridVue} from 'ag-grid-vue'
import Pagination from '../../ui-elements/Pagination.vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import moment from 'moment'
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import {isAPI, isRouter} from '../../../store/permission'
import {constAPI, constRouter} from '../../../store/constant'

export default {

    components: {
        vSelect,
        AgGridVue,
        Pagination,
        CellRendererActions,
        DateRangePicker
    },

    data() {
        return {
            userInfo: {},
            holidayOption: [],
            holidayData: [],
            holidayInfo: {},
            searchQuery: '',
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'Tên ngày nghỉ',
                    field: 'holidayName',
                    width: 400,
                    sortable: true,
                },
                {
                    headerName: 'Ngày bắt đầu',
                    field: 'fromDate',
                    width: 400,
                    sortable: true,
                },
                {
                    headerName: 'Ngày kết thúc',
                    field: 'toDate',
                    width: 400,
                    sortable: true,
                },
                {
                    headerName: 'Hành động',
                    field: 'actions',
                    width: 200,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                },
            ],
            organizationBranchValue: null,
            optionSelected: [],
            showSubBranch: false,
            showChilrenBranch: false,

            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            valueSelectedBranch: null,
            levelBranch: null,
            checkValueSelected: false,

            checkSelectedSub: false,
            checkSelectedChilren: false,
            isFirstCallApi: false,

            dateRange: {
                startDate: new Date(new Date().getFullYear(),0,1),
                endDate:  new Date(new Date().getFullYear(),11,31)
            },
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
        }
    },

    created() {
        this.initScreen()
    },

    watch: {
        '$store.state.isUpdateHoliday'(val) {
            if (val) {
                this.initScreen()
                this.$store.commit('UPDATE_HOLIDAY', false);
            }
        }
    },

    computed: {
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue, this.organizationBranchOptions),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null;
            }
        },
    },


    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.holiday_add)
        },
        dateRangePicker: function() {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },

        filter() {
            this.currentPage = 1;
            if (this.gridApi) this.gridApi.paginationGoToPage(this.currentPage - 1)
            this.getAllHoliday();
        },

        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },

        addHoliday() {
            this.$router.push(`/user/manage-holiday-info`)
        },

        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },

        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: 'Không tồn tại ngày nghỉ nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(el => {
                return {
                    value: el.id,
                    label: el.organizationBranchName
                }
            })
            this.organizationBranchOptions.unshift({value: null, label: 'Tất cả'})
            this.getAllHoliday(false);
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },

        getAllHoliday(check) {

            this.$vs.loading();
            const payload = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                fromDate: this.dateRange.startDate,
                toDate: this.dateRange.endDate,
            }

            this.$crm.post('/holiday/find-by-condition', payload).then((response) => {
                this.$vs.loading.close();
                let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
                this.holidayData = response.data.map(el => {
                    el.fromDate = moment(el.fromDate).format('DD/MM/YYYY');
                    el.toDate = moment(el.toDate).format('DD/MM/YYYY');
                    branchList.forEach(branch => {
                        if (el.organizationBranchId == branch.id) el.branchName = branch.organizationBranchName;
                    })
                    el.holidayName = el.holidayName.toUpperCase();
                    return el;
                });
                this.holidayData = this.holidayData.sort((x, y) => {
                    return y.id - x.id
                })
                this.countElementPage = this.currentPage * 10;
                this.totalElements = this.holidayData.length;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        loadDataToSelect: function (data, level, branchId) {
            if (!data) return;
            data = this.optionSelected.filter(el => el.level == level && el.patch && el.patch.includes(branchId));
            return data.map(el => {
                return {
                    value: el.id,
                    label: el.organizationBranchName
                }

            });
        },

        organizationBranchString(id, data) {
            let organizationBranch = data.find(x => x.value == id);
            return (organizationBranch && organizationBranch.label) || 'Chưa xác định';
        },

    },
}
</script>

<style lang="scss">
.pagination-table {
    button {
        min-width: 160px !important;
    }
}

.ag-paging-panel {
    display: none;
}
</style>
